/**
 * @file React Query hook loading bidder lots + scan-status in parallel.
 */

import { useQuery } from '@tanstack/react-query';
import { getBidderLots, getBidderLotsWithScanStatus } from '../api/bidders';
import { queryKeys } from '../api/queryKeys';

export function useExpandedBidderLots(bidderId, auctionGroupId, enabled) {
  const lotsQuery = useQuery({
    queryKey: queryKeys.bidderLots(bidderId, auctionGroupId),
    queryFn: () => getBidderLots(bidderId, auctionGroupId),
    enabled: enabled && !!bidderId && !!auctionGroupId,
  });

  const scanQuery = useQuery({
    queryKey: queryKeys.bidderLotsScan(bidderId, auctionGroupId),
    queryFn: () => getBidderLotsWithScanStatus(bidderId, auctionGroupId),
    enabled: enabled && !!bidderId && !!auctionGroupId,
  });

  return {
    lots: lotsQuery.data,
    lotsWithScan: scanQuery.data,
    isLoading: lotsQuery.isLoading || scanQuery.isLoading,
    error: lotsQuery.error || scanQuery.error,
    refetch: () => Promise.all([lotsQuery.refetch(), scanQuery.refetch()]),
  };
}
